<template>
  <b-row>
    <b-col
      lg="10"
    >
      <div class="auth-wrapper auth-v1 px-2">
        <div class="auth-inner py-2 margin-250">

          <!-- unsubscribe email -->
          <b-card class="mb-0">
            <b-link class="brand-logo">
              <vuexy-logo />
              <h2 class="brand-text text-primary ml-1" />
            </b-link>

            <b-card-title class="mb-1">
              {{ $t('DEBTIA_UNSUBSCRIBE_NEWSLETTER') }}
            </b-card-title>
            <b-alert
              v-if="successResponse"
              variant="primary"
              show
            >
              <div class="alert-body">
                <span>{{ responseMessage }}</span>
              </div>
            </b-alert>
            <div v-else>
              <b-card-text class="mb-2">
                {{ $t('DEBTIA_ENTER_EMAIL_UNSUBSCRIBE_NEWSLETTER') }}
              </b-card-text>
              <b-alert
                v-height-fade.appear
                :show="dismissCountDown"
                dismissible
                fade
                :variant="msgVariant"
                class="mb-0"
                @dismiss-count-down="countDownChanged"
              >
                <div class="alert-body">
                  <span>{{ responseMessage }}</span>
                </div>
              </b-alert>
              <!-- form -->
              <validation-observer ref="simpleRules">
                <b-form
                  class="auth-unsubscribe-form mt-2"
                  @submit.prevent="validationForm"
                >
                  <!-- email -->
                  <b-form-group
                    label="Email"
                    label-for="unsubscribe-email"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Email"
                      rules="required|email"
                    >
                      <b-form-input
                        id="unsubscribe-email"
                        v-model="userEmail"
                        :state="errors.length > 0 ? false:null"
                        name="unsubscribe-email"
                        placeholder="john@example.com"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>

                  <!-- submit button -->
                  <b-button
                    variant="primary"
                    block
                    type="submit"
                  >
                    <b-spinner
                      v-if="loader"
                      class="mr-1"
                      variant="primary"
                      small
                    />
                    {{ loader ? '' : $t('DEBTIA_SUBMIT') }}
                  </b-button>
                </b-form>
              </validation-observer>
            </div>
          </b-card>
        <!-- /unsubscribe email -->
        </div>
      </div>
    </b-col>

    <b-col
      lg="2"
    >
      <b-navbar-nav class="nav align-items-center ml-auto language-bar">
        <locale />

      </b-navbar-nav>
    </b-col>
  </b-row>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import locale from '@core/layouts/components/app-navbar/components/Locale.vue'
import { heightFade } from '@core/directives/animations'
import useAppConfig from '@core/app-config/useAppConfig'
import axios from '@axios'
import {
  BCard, BLink, BCardText, BCardTitle, BFormGroup, BFormInput, BForm, BButton, BAlert, BNavbarNav, BRow, BCol, BSpinner,
} from 'bootstrap-vue'
import { required, email } from '@validations'

export default {
  components: {
    BAlert,
    VuexyLogo,
    BCard,
    BLink,
    BCardText,
    BCardTitle,
    BFormGroup,
    BFormInput,
    BButton,
    BForm,
    ValidationProvider,
    ValidationObserver,
    BNavbarNav,
    locale,
    BRow,
    BCol,
    BSpinner,
  },
  directives: {
    heightFade,
  },
  data() {
    return {
      userEmail: '',
      // validation
      required,
      email,
      dismissSecs: 7,
      dismissCountDown: 0,
      responseMessage: '',
      msgVariant: '',
      successResponse: false,
      loader: false,
    }
  },
  setup() {
    const { skin } = useAppConfig()

    if (skin.value === 'dark') document.body.classList.remove('dark-layout')
  },
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    validationForm() {
      this.msgVariant = ''
      this.responseMessage = ''
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.loader = true
          const url = '/clients/newsletter/unsubscribe'
          axios.post(url, {
            email: this.userEmail,
          }).then(response => {
            if (response.status === 200) {
              setTimeout(() => {
                this.loader = false
                this.successResponse = true
                this.userEmail = ''
                this.msgVariant = 'primary'
                this.dismissCountDown = this.dismissSecs
                this.responseMessage = response.data.message
                this.$refs.simpleRules.reset()
              }, 1000)
            }
          }).catch(error => {
            setTimeout(() => {
              this.loader = false
              this.successResponse = false
              this.msgVariant = 'danger'
              this.dismissCountDown = this.dismissSecs
              const { message } = error.response.data
              const [firstMessage] = message
              this.responseMessage = firstMessage
            }, 1000)
          })
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
.margin-250 {
  margin-left: 250px;
}
</style>
